import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { CompactTable } from "@table-library/react-table-library/compact";
import { useTheme } from "@table-library/react-table-library/theme";
import { getTheme } from "@table-library/react-table-library/baseline";
import { usePagination } from "@table-library/react-table-library/pagination";

const dokumenta = [
  {
    id: "1",
    naziv: "Dokument 1",
    ekstenzija: "pdf"
  },
  {
    id: "2",
    naziv: "Dokument 2",
    ekstenzija: "pdf"
  },
  {
    id: "3",
    naziv: "Dokument 3",
    ekstenzija: "pdf"
  }
];

function PravilnikORadu() {
  const [rows, setRows] = useState(dokumenta);
  const [newFile, setNewFile] = useState(null);

  const fileInputRef = useRef(null);

  const [search, setSearch] = useState("");

  const theme = useTheme(getTheme());

  const data = {
    nodes: rows.filter((item) =>
      item.naziv.toLowerCase().includes(search.toLowerCase())
    )
  };

  const COLUMNS = [
    { label: "Naziv", renderCell: (item) => item.naziv },
    { label: "Tip", renderCell: (item) => item.ekstenzija },
    {
      label: "Pregledaj",
      renderCell: (item) => (
        <button onClick={() => handlePreview(item.id)}>Pregledaj</button>
      )
    },
    {
      label: "Brisanje",
      renderCell: (item) => (
        <button onClick={() => handleDelete(item.id)}>Obrisi</button>
      )
    }
  ];

  const handleDelete = (id) => {
    setRows((prev) => prev.filter((r) => r.id !== id));
  };

  const handlePreview = (id) => {
    console.log(id);
  };

  const handleInputChange = (e) => setSearch(e.target.value);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const extension = file.name.split(".").pop();
    setRows((prev) => [
      ...prev,
      { id: Math.random(), naziv: file.name, ekstenzija: extension }
    ]);

    fileInputRef.current.value = "";
  };

  const handleAddNewFile = () => {
    fileInputRef.current.click();
  };

  const pagination = usePagination(data, {
    state: {
      page: 0,
      size: 10
    }
  });

  return (
    <div
      style={{ padding: "25px", backgroundColor: "#f9f9f9", height: "100%" }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <input
          type="text"
          placeholder="Pretraga..."
          value={search}
          onChange={handleInputChange}
          style={{ padding: "7px", width: "25%", fontSize: "16px" }}
        />
        <input type="file" onChange={handleFileChange} ref={fileInputRef} />
        <button onClick={handleAddNewFile}>Dodaj novi dokument</button>
      </div>

      <CompactTable
        columns={COLUMNS}
        data={data}
        theme={theme}
        pagination={pagination}
      />

      <br />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>
          Ukupan broj stranica: {pagination.state.getTotalPages(data.nodes)}
        </span>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          Stranica{" "}
          <button
            type="button"
            disabled={pagination.state.page === 0}
            onClick={() => pagination.fns.onSetPage(0)}
          >
            {"<<"}
          </button>
          <button
            type="button"
            disabled={pagination.state.page === 0}
            onClick={() => pagination.fns.onSetPage(pagination.state.page - 1)}
          >
            {"<"}
          </button>
          <span>{pagination.state.page + 1}</span>
          <button
            type="button"
            disabled={
              pagination.state.page + 1 ===
              pagination.state.getTotalPages(data.nodes)
            }
            onClick={() => pagination.fns.onSetPage(pagination.state.page + 1)}
          >
            {">"}
          </button>
          <button
            type="button"
            disabled={
              pagination.state.page + 1 ===
              pagination.state.getTotalPages(data.nodes)
            }
            onClick={() =>
              pagination.fns.onSetPage(
                pagination.state.getTotalPages(data.nodes) - 1
              )
            }
          >
            {">|"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PravilnikORadu;
